import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import BlackClose from '../../../../assets/image/x-squareBlack.svg';
import ProfilePlaceHolder from '../../../../assets/image/emailPlaceHolder.svg';
import ProductDetails from '../../../purchaseOrder/Navigation/ProductDetails';
import Transactions from '../../../purchaseOrder/Navigation/Transactions';

function PurchaseOrderMoreInfoSidebar({ isSidebarOpen, setIsSidebarOpen }) {
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;
	const [productDetails, setProductDetails] = useState(null);
	const navTabs = ['Product Details', 'Transactions'];
	const [activeTab, setActiveTab] = useState('Transactions');

	const renderTabContent = () => {
		switch (activeTab) {
			case 'Product Details':
				return <ProductDetails productDetails={productDetails} />;
			case 'Transactions':
				return <Transactions />;
			default:
				return null;
		}
	};

	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	return (
		<div className="sidebar">
			<div
				className="d-flex align-self-center justify-content-sm-between "
				style={{ gap: '60px' }}
			>
				<div className="VenderDetails">Product Details</div>

				<div
					className="d-flex align-self-center "
					style={{ gap: '26px', alignItems: 'center' }}
				>
					<div>
						<Link to={`/user/${suburl}/purchases-order-details/${id}`}>View more details</Link>
					</div>

					<div
						className="SidebaarCloseBTN d-flex align-self-center justify-content-sm-center"
						onClick={toggleSidebar}
					>
						<img
							src={BlackClose}
							alt=""
							style={{ width: '14px', cursor: 'pointer' }}
						/>
					</div>
				</div>
			</div>

			<br />

			<div
				className="d-flex"
				style={{ gap: '20px' }}
			>
				<div className="profileImage d-flex align-self-center justify-content-sm-center">
					<img
						src={ProfilePlaceHolder}
						alt=""
						style={{ width: '55px', borderRadius: '10px' }}
					/>
				</div>

				<div
					className="d-flex flex-column"
					style={{ gap: '15px' }}
				>
					<div
						style={{
							fontSize: '18px',
							fontWeight: '600',
							color: '#333',
						}}
					>
						{productDetails?.product?.product_name}
					</div>

					<div
						style={{
							fontSize: '14px',
							color: 'var(--sub, #555B67)',
						}}
					>
						<b>{productDetails?.product_packaging}</b> contains{' '}
						<b>{productDetails?.product?.contains}</b>
					</div>
				</div>
			</div>
			<br />
			<hr />

			{/* tabs  */}
			<div>
				<ul className="nav mb-4 mt-2">
					{navTabs.map((item, index) => (
						<li
							key={index}
							className="nav-item"
						>
							<a
								className={`nav-link ${activeTab === item ? 'active' : ''} cursur-pointer`}
								href="#"
								onClick={(e) => {
									e.preventDefault();
									setActiveTab(item);
								}}
							>
								{item}
							</a>
						</li>
					))}
				</ul>
				<hr
					style={{
						backgroundColor: '#E3E4E5',
						boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
						marginTop: '-13px',
					}}
				/>
				<div>{renderTabContent()}</div>
			</div>
		</div>
	);
}

export default PurchaseOrderMoreInfoSidebar;
